import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

interface MultiSelectProps {
  options: Array<{ value: string; label: string }>;
  value: Array<{ value: string; label: string }>;
  onChange: (value: any) => void;
  isMulti?: boolean;
  placeholder?: string;
  isCurrentStatusChecked?: boolean;
}


export default function MultiSelectCustom({
  options,
  value,
  onChange,
  isMulti = true,
  placeholder = 'Select...',
}: MultiSelectProps) {
  const handleChange = (selected) => {
    if (selected.some(option => option.value === 'selectAll')) {
      onChange(options);
    } else {
      onChange(selected);
    }
  };

  const filteredValue = value.filter(option => option.value !== 'selectAll');

  return (
    <Select
      closeMenuOnSelect={!isMulti}
      components={{ ...animatedComponents }}
      options={options}
      isMulti={isMulti}
      onChange={handleChange}
      value={filteredValue}
      placeholder={placeholder}
    />
  );
}
